import { Icon, Spinner, Text } from "@ttc3k/trekker";
import { ArrowSeparateVertical } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";

type ComboboxLoaderProps = {
  text?: string;
  iconColor?: string;
  spinnerColor?: string;
};

export const ComboboxLoader = ({
  text,
  iconColor,
  spinnerColor,
}: ComboboxLoaderProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      justifyContent={"space-between"}
      alignItems={"center"}
      gap="100"
      bgColor="white"
      border="1px solid"
      borderColor="border.light"
      borderRadius="100"
      pl="150"
      pr="11px"
      py="100"
    >
      <Flex flexDir={"row"} gap="100" alignItems={"center"}>
        <Spinner w="24px" h="24px" color={spinnerColor || "border.mid"} />
        <Text visual="bodyRegular" color="text.light">
          {text || t("core:LOADING")}...
        </Text>
      </Flex>
      <Icon Element={ArrowSeparateVertical} color={iconColor || "icon.mid"} />
    </Flex>
  );
};
